/*jshint esversion: 11 */
import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { connect } from 'react-redux';
import classnames from 'classnames';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import ActiveSessionsTab from './ActiveSessionsTab';
import LoginHistoryTab from './LoginHistoryTab';

const SessionsPage = ({ authUser }) => {
  const [activeTab, setActiveTab] = useState('active');

  const breadcrumbItems = [
    { title: 'Sessions', link: '#' },
    { title: 'Manage', link: '#' }
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Sessions" breadcrumbItems={breadcrumbItems} />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Nav tabs className="mb-4">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 'active' })}
                      onClick={() => setActiveTab('active')}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="ri-user-follow-line mr-1"></i> Active Sessions
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 'history' })}
                      onClick={() => setActiveTab('history')}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="ri-history-line mr-1"></i> Login History
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="active">
                    {activeTab === 'active' && (
                      <ActiveSessionsTab currentUserId={authUser?._id} />
                    )}
                  </TabPane>
                  <TabPane tabId="history">
                    {activeTab === 'history' && <LoginHistoryTab />}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({ authUser: state.Login.user });
export default connect(mapStateToProps)(SessionsPage);
